import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthProvider';
import logo from '../../assets/images/headerLogo/logo.jpg'


const Header = () => {

    const { user, logOut } = useContext(AuthContext)

    const handleLogOut = () => {
        logOut()
            .then()
            .catch(error => console.error(error))
    }

    const menuItems = <>
        {/* <li className='font-semibold'><Link to={'/'}>Home</Link></li> */}
        <li className='font-semibold'><Link to={'/allServices'}>All Services</Link></li>
        <li className='font-semibold'><Link to={'/blog'}>Blog</Link></li>
        {
            user?.email ?
                <>
                    <li className='font-semibold'><Link to={'/myReviews'}>My reviews</Link></li>
                    <li className='font-semibold'><Link to={'/addService'}>Add service</Link></li>
                    <li className='font-semibold'>
                        <button onClick={handleLogOut} className='btn-ghost'>Sign Out</button>
                    </li>
                </>
                :
                <li className='font-semibold'><Link to={'/login'}>Login</Link></li>
        }
    </>

    return (
        <div>
            <div className="navbar h-12 mb-4 pt-4 bg-base-100">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                            {menuItems}
                        </ul>
                    </div>
                    <Link to={'/'} className="btn btn-ghost normal-case text-xl">
                        <p className='text-2xl font-bold'>PARADISE</p>
                        {/* <img className='h-14 w-14' src={logo} alt="" /> */}
                    </Link>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        {menuItems}
                    </ul>
                </div>
                <div className="navbar-end">
                    {/* <button className="btn btn-outline btn-warning">Appointment</button> */}

                </div>
            </div>
        </div>
    );
};

export default Header;